const _ = require('underscore');
const React = require('react');
const Dropdown = require('../../deploynaut/js/components/Dropdown.jsx');
const Checkbox = require('../../deploynaut/js/components/Checkbox.jsx');
const Dashboard = require('./Dashboard.jsx');
const createReactClass = require("create-react-class");

const Metrics = createReactClass({
	getInitialState: function() {
		return {
			model: this.props.model,
			selectedDashboard: null,
			selectedTimeRange: this.props.model.DefaultTimeRange,
			showDeployments: false,
			showVirtualStacks: false,
		};
	},

	componentWillMount: function() {
		const firstDashboard = _.first(this.state.model.Dashboards);
		this.toggleDashboard(firstDashboard.id);
	},

	toggleDashboard: function(dashboard) {
		this.setState({
			selectedDashboard: parseInt(dashboard)
		});
	},

	toggleTimeRange: function(timeRange) {
		this.setState({
			selectedTimeRange: timeRange
		});
	},

	toggleVirtualStackMetrics: function(event) {
		this.setState({
			showVirtualStacks: event.target.checked
		});
	},

	toggleDeployments: function(event) {
		this.setState({
			showDeployments: event.target.checked
		});
	},

	render: function() {
		const dashboardOptions = [];
		const timeRanges = [];
		const self = this;

		const dashboards = _.map(this.state.model.Dashboards, function(item) {
			dashboardOptions.push({
				id: item.id,
				title: item.name
			});

			return (
				<Dashboard
					key={item.id}
					item={item}
					model={self.state.model}
					selected={item.id === self.state.selectedDashboard}
					timeRange={self.state.selectedTimeRange}
					showDeployments={self.state.showDeployments}
					showVirtualStacks={self.state.showVirtualStacks}
				/>
			);
		});

		_.map(this.state.model.TimeRanges, function(name, index) {
			timeRanges.push({
				id: index,
				title: name
			});
		});

		return (
			<div className="metrics">
				<div className="row">
					<div className="col-sm-6">
						<h3>Metrics</h3>
					</div>

					<div className="col-sm-3">
						<Checkbox
							id={0}
							name='show-deployments'
							description='Show recent deployments'
							checked={this.state.showDeployments}
							onClick={this.toggleDeployments}
						/>

						{this.state.model.ShowVirtualStackOption ? (
							<Checkbox
								id={1}
								name='show-virtual-stack'
								description='Include metrics from virtual stacks'
								checked={this.state.showVirtualStacks}
								onClick={this.toggleVirtualStackMetrics}
							/>
						) : ''}
					</div>

					<div className="col-sm-3">
						{dashboardOptions.length > 1 ? (
							<Dropdown
								name="metric-dropdown"
								onSelect={this.toggleDashboard}
								value={this.state.selectedDashboard}
								options={dashboardOptions}
							/>
						) : ''}

						<Dropdown
							name="metric-time-selector"
							onSelect={this.toggleTimeRange}
							value={this.state.selectedTimeRange}
							options={timeRanges}
						/>
					</div>
				</div>

				<div className='dashboard-content'>
					{dashboards}
				</div>
			</div>
		);
	}
});

module.exports = Metrics;
